// Copyright (c) 2021 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import { PoolOrderCodesTable, SalesOrderCodesTable } from './components/pool-order-exchange-detail-table';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import {
    getPoolOrderExchangeDetails, getPoolOrderExchangeOrderNumbers
} from './repositories';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class PoolOrderExchangeDetail extends Component {

    state = {
        orderNumbers: [],
        selectedOrderNumber: '',
        results: null
    };

    componentDidMount = () => {

        const query = new URLSearchParams( this.props.location.search );
        const queryOrderNum = query.get( 'ordernumber' );

        this.props.increaseCounter();
        getPoolOrderExchangeOrderNumbers().then( response => {

            this.setState( {
                orderNumbers: response.map( i => ( {
                    id: i,
                    value: i
                } ) )
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

        if ( queryOrderNum ) {

            this.setState( {
                selectedOrderNumber: queryOrderNum
            }, () => this.refresh() );

        }

    }

    handleTypeChange ( val ) {

        this.setState( {
            selectedOrderNumber: val
        }, () => {

            this.refresh();

        } );

    }

    refresh ( ) {

        if ( this.state.selectedOrderNumber !== '' || this.state.selectedOrderNumber !== '-1' ) {

            this.props.increaseCounter();
            getPoolOrderExchangeDetails( this.state.selectedOrderNumber )
                .then( response => {

                    this.setState( {
                        results: response
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

        }

    }

    render () {

        const {
            selectedOrderNumber, orderNumbers, results
        } = this.state;

        const additionalInfo = ( results !== null ? {
            unitName: this.props.unit.name
        } : '' );
        const poolCodesList = results && results.poolCodesList.map(
            i => ( {
                ...i,
                ...additionalInfo
            } )
        );
        const salesCodeList = results && results.salesCodeList.map(
            i => ( {
                ...i,
                ...additionalInfo
            } )
        );

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">ATP Pool Order Exchange Details</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-pool-order-exchange-detail-top-options">
                            <div className="select-options">
                                <OptionsDropDown
                                    className="atp-pool-order-exchange-detail-select"
                                    label="Order Number"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleTypeChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={orderNumbers}
                                    placeholder="Select Order Number"
                                    selectedValue={selectedOrderNumber}
                                />
                                {selectedOrderNumber && <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" /></span>}
                            </div>
                        </div>
                        <div className="atp-pool-order-exchange-detail-results-section">
                            {( selectedOrderNumber && results !== null ) && (
                                <SalesOrderCodesTable
                                    list={salesCodeList}
                                    salesOrderCode={results.salesCode}
                                />
                            )}
                            {( selectedOrderNumber && results !== null ) && (
                                <PoolOrderCodesTable
                                    list={poolCodesList}
                                    poolOrderCode={results.poolCode}
                                />
                            )}
                        </div>
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

PoolOrderExchangeDetail.displayName = 'PoolOrderExchangeDetail';
PoolOrderExchangeDetail.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( PoolOrderExchangeDetail ) );
